import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';
import { Link } from '@inertiajs/inertia-vue3';

import { ElMessageBox, ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  components: {
    Head: Head,
    Link: Link
  },
  layout: Layout,
  props: {},
  data: function data() {
    return {
      userList: [],
      isLoadingMapping: true,
      isLoadingPaginate: true,
      currentPage: 1,
      userStatus: "all",
      searchValue: "",
      totalCount: 0,
      showInactive: false
    };
  },
  mounted: function mounted() {
    this.getUserList(true);
  },
  methods: {
    getUserList: function getUserList() {
      var _arguments = arguments,
        _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var resetPaginate, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resetPaginate = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
                if (resetPaginate) {
                  _this.isLoadingPaginate = true;
                  _this.currentPage = 1;
                }
                _this.isLoadingMapping = true;
                _context.next = 5;
                return axios.post('/user_management/list', {
                  page: _this.currentPage,
                  search: _this.searchValue,
                  getCount: resetPaginate,
                  userStatus: _this.userStatus
                });
              case 5:
                res = _context.sent;
                if (res.data.status == 'success') {
                  _this.userList = res.data.userList;
                  if (resetPaginate) {
                    _this.totalCount = res.data.userCount;
                  }
                }
                _this.isLoadingMapping = false;
                _this.isLoadingPaginate = false;
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    pageChange: function pageChange(current_page) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.currentPage = current_page;
                _context2.next = 3;
                return _this2.getUserList();
              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    updateUserAccess: function updateUserAccess(userData) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var performAction, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                performAction = true;
                _context3.next = 3;
                return ElMessageBox.confirm('Are you sure to update access of this user.', 'Warning', {
                  confirmButtonText: 'Confirm',
                  cancelButtonText: 'Cancel',
                  type: 'warning'
                }).then(function () {})["catch"](function () {
                  ElMessage({
                    type: 'info',
                    message: 'Canceled'
                  });
                  performAction = false;
                });
              case 3:
                if (performAction) {
                  _context3.next = 7;
                  break;
                }
                _context3.next = 6;
                return _this3.getUserList();
              case 6:
                return _context3.abrupt("return", performAction);
              case 7:
                _this3.$store.loading = true;
                _context3.next = 10;
                return axios.post('/user_management/update', userData);
              case 10:
                res = _context3.sent;
                ElMessage({
                  showClose: true,
                  message: res.data.msg,
                  type: res.data.status
                });
                _this3.$store.loading = false;
                _context3.next = 15;
                return _this3.getUserList();
              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};